/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {Icon} from "../model/icon";
import {Iconset} from "../model/iconset";

@Injectable({
    providedIn: "root",
})
export class SimIconsetService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteTextMarker(textMarker: Icon) {
        return super.post<boolean>(`/api/Iconset/DeleteTextMarker`, textMarker);
    }

    public getIconsetById(iconsetId: string) {
        return super.get<Iconset>(`/api/Iconset/GetIconsetById`, {iconsetId: iconsetId});
    }

    public listIconsets() {
        return super.get<Iconset[]>(`/api/Iconset/ListIconsets`, );
    }

    public upsertIconset(iconset: Iconset) {
        return super.post<boolean>(`/api/Iconset/UpsertIconset`, iconset);
    }

    public upsertTextMarkerIconset(iconset: Iconset) {
        return super.post<boolean>(`/api/Iconset/UpsertTextMarkerIconset`, iconset);
    }
}